// Stripe zero-decimal currencies, same list used in www-spa.
// https://docs.stripe.com/currencies#zero-decimal
// UGX and ISK are intentionally NOT listed: Stripe treats them as two-decimal currencies.
export const ZERO_DECIMAL_CURRENCIES = [
    'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA',
    'PYG', 'RWF', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'
]

export const isZeroDecimalCurrency = currency => ZERO_DECIMAL_CURRENCIES.includes(String(currency || '').toUpperCase())

// Prices in zero-decimal currencies must be integers, otherwise the amount sent to Stripe gets rounded.
export const currencyDecimals = currency => isZeroDecimalCurrency(currency) ? 0 : 2

export const roundToCurrency = (value, currency) => {
    return parseFloat(Number(value).toFixed(currencyDecimals(currency)))
}

// Stripe expects amounts in the currency's smallest unit: ¥1234 -> 1234, €12.34 -> 1234
export const toStripeAmount = (amount, currency) => {
    const value = Number(amount)
    return isZeroDecimalCurrency(currency) ? Math.round(value) : Math.round(value * 100)
}
